import React, { useState, useEffect, use } from 'react'
import { Pagination } from '@mui/material';
import { getGroupAssignmentByAssingedToDept,getRoleAssignView, SaveBulkAssignLoansByData } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import GroupIcon from '@mui/icons-material/Group';
import LoopIcon from '@mui/icons-material/Loop';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { useSelector } from 'react-redux';
import { Company_DATA } from '../../../../../layouts/MainTenantconfig';

const initalDate = (type) => {
    const date = new Date();
    if (type == "from") {
        date.setDate(date.getDate() - 7);
        return date.toISOString().split('T')[0];
    } else if (type == "to") {
        const d = moment(date).format("YYYY-MM-DD")
        return d
    }

}

const itemsPerPage = 10;
export default function AssignedLeadsOlderThanDay({ userDetailHandler ,allStatus, admin}) {
    const tenant = useSelector((state) => state.tenant.activeTenant);
        const [bulkAssign, setBulkAssign] = useState(false)
    const [bulkAssignedData, setBulkAssignedData] = useState([])
    const [assignPopup, setAssingPopup] = useState({ show: false, selectedId: '' })
    const [payload, setPayload] = useState({
        sDate: initalDate("from"),
        eDate: initalDate("to")
    })
    const [viewType, setViewType] = useState("")
    const [apiData, setApiData] = useState({})
    const [loader, setloader] = useState(false);
    const [allUserDetail, setallUserDetail] = useState({})
    const [paginationState, setPaginationState] = useState({});
     const [roleList, setRoleList] = useState([])
    const [popup, setpopup] = useState({show:false,popupStatus:''})

    useEffect(() => {
        console.log("allStatus", allStatus)
        getGroupAssignmentByAssingedToDeptFn(payload)
         getRoleAssignViewFn()
    }, [])

    const getRoleAssignViewFn = () => {
        getRoleAssignView(admin?.emailId, callback => {
            setRoleList(callback)
        })
    }

    const handleViewType = (value) => {
        setViewType(value)
        console.log("s", value, apiData?.[value])
        setallUserDetail(apiData?.[value])
    }

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleChangeNewPagination = (entryKey, newPage) => {
        setPaginationState(prev => ({
            ...prev,
            [entryKey]: newPage
        }));
    };

    const handleFilter = () => {
        getGroupAssignmentByAssingedToDeptFn(payload)
    }

    const getGroupAssignmentByAssingedToDeptFn = (data) => {
        const start = moment(data?.sDate).format('DD-MM-YYYY')
        const end = moment(data?.eDate).format('DD-MM-YYYY')

        setloader(true)
        getGroupAssignmentByAssingedToDept(start, end, callback => {
            setloader(false)
            console.log("ca", callback?.data)
            if (callback?.status == 200 && callback?.message == "success") {
                setApiData(callback?.data)
                // setallUserDetail(callback?.data)
            } else {
                setApiData({})
                setallUserDetail({})
            }
        })
    }

    const HandleDate = (timeStamp) => {
        if (timeStamp == null || timeStamp == undefined || timeStamp == "") {
            return "-"
        }
        const d = new Date(timeStamp);
        const date = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();

        return `${date}-${month}-${year}`;
    };

    // const calculateTotalCount = (categoryData) => {

    //     const updatedData = apiData?.[categoryData];
    //     let count = 0;
    //     const a = Object.entries(updatedData)?.map(([key, value], id) => {
    //         count += value?.length;
    //     })

    //     return count


    // };
    const calculateTotalCount = (categoryData) => {
        const data = apiData?.[categoryData];

        if (!data || typeof data !== 'object') {
            return 0;
        }

        let count = 0;

        Object.entries(data).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                count += value.length;
            }
        });

        return count;
    };

    const handleBulkAssign = (type) => {
        setBulkAssign(type)
        setBulkAssignedData([])
    }

    const handleCheckbox = (e, data) => {
        const { checked } = e.target;
        const obj = {
            "loanId": data?.loanId,
            "type": "Loan",
            "userId": data?.userId
        }
        if (checked) {

            const isAlreadyPresent = bulkAssignedData.some(item => item.loanId === data?.loanId);
            if (!isAlreadyPresent) {
                setBulkAssignedData(prev => [...prev, obj]);
            }
        } else {
            setBulkAssignedData(prev => prev.filter(item => item.loanId !== data?.loanId));
        }


    }

    const isItemSelected = (loanId) => {
        return bulkAssignedData.some(item => item.loanId === loanId);
    };


    const handleAssignmentPopup = (type) => {
        setAssingPopup({ show: type, selectedId: '' })
    }

    const handleFinalAssignment = () => {


        const data = bulkAssignedData.map(item => ({
            ...item,
            empId: assignPopup?.selectedId,
            assignedBy: admin?.emailId

        }));

        const updateData = {
            assignments:data
        }
      

        setloader(true)
        SaveBulkAssignLoansByData(updateData,callback=>{
            console.log("data",callback)
            setloader(false)
            if(callback == "success"){
                   setpopup({show:true,popupStatus:'Leads Assigned Successfully'})
            }else{
                setpopup({show:true,popupStatus:'Error Assigning Leads'})
            }
            removePopup()
            handleAssignmentPopup(false)
            setBulkAssignedData([])
            getGroupAssignmentByAssingedToDeptFn(payload)
            setBulkAssign(false)
        })
    }

    const closepopup=()=>{
        setpopup({show:false,popupStatus:''})
    }

    const removePopup = ()=>{
        setTimeout(()=>{
closepopup()
        },5000)
    }



    return (
        <>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                {
                    loader ? <Loader /> : ""
                }

                 {popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closepopup}/>
                :''}
                <div className="row">
                    <div className="col-sm-2 col-xs-4">
                        <label htmlFor="">Start Date</label>
                        <input type='date' value={payload?.sDate} onChange={(e) => handlechange(e, "sDate")} className='form-control' />
                    </div>
                    <div className="col-sm-2 col-xs-4">
                        <label htmlFor="">End Date</label>
                        <input type='date' value={payload.eDate} onChange={(e) => handlechange(e, "eDate")} className='form-control' />
                    </div>
                    <div className="col-sm-2 col-xs-4">
                        <label htmlFor="">Status</label>
                        <select className='form-control' value={payload?.status} onChange={(e) => handlechange(e, "status")}>
                            <option>Select Status</option>
                            {
                                allStatus?.length > 0 ? allStatus?.map((value, id) => {
                                    return (

                                        <option value={value?.statusId}>{value?.adminStatus}</option>
                                    )
                                })
                                    : ''}
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-4">
                        <button className='btn btn-primary' style={{ marginTop: '22px',  color: '#fff', padding: '10px' }} onClick={() => handleFilter()}>Apply Filter</button>
                    </div>
                     <div className="col-sm-2 col-xs-4" style={{ float: 'right', textAlign: 'end' }}>
                        {
                            bulkAssign == false ?
                                <button className='btn' style={{ marginTop: '22px', background: '#4d84c7', color: '#fff', padding: '10px' }} onClick={() => handleBulkAssign(true)}>Bulk Assign</button>
                                :
                                <>
                                    <div style={{ display: 'flex' }}>
                                        <button className='btn' style={{ marginTop: '22px', background: 'red', color: '#fff', padding: '10px' }} onClick={() => handleBulkAssign(false)}><i className='fa fa-times'></i>&nbsp; Cancel</button>&nbsp;
                                        <button className='btn' disabled={bulkAssignedData?.length > 0 ? false : true} style={{ marginTop: '22px', background: '#4d84c7', color: '#fff', padding: '10px' }} onClick={() => handleAssignmentPopup(true)}>Assign</button>
                                    </div>
                                </>
                        }
                    </div>
                </div>


                <div className="row">
                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                        <div className='customCardscss'>
                            <div className='greenTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <GroupIcon style={{ fontSize: '30px' }} />
                                    </div>
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#0b4e22' }}>{apiData && Object.keys(apiData)?.length > 0 ? calculateTotalCount('customerService') : 0}</h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${viewType == "customerService" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#22723d',
                                        cursor: 'pointer'

                                    }}
                                    onClick={() => handleViewType("customerService")}
                                >
                                    Customer Service <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                        <div className='customCardscss'>
                            <div className='blueTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <CreditCardIcon style={{ fontSize: '30px' }} />
                                    </div>
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#1d4ed8' }}>{apiData && Object.keys(apiData)?.length > 0 ? calculateTotalCount('credit') : 0}</h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${viewType == "credit" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#1e3a8a',
                                        cursor: 'pointer'

                                    }}
                                    onClick={() => handleViewType("credit")}
                                >
                                    Credit <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>


                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                        <div className='customCardscss'>
                            <div className='purpleTheme'>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="Iconcontent">
                                        <LoopIcon style={{ fontSize: '30px' }} />
                                    </div>
                                    <h5 style={{ fontSize: '30px', fontWeight: '700', color: '#6617be' }}>{apiData && Object.keys(apiData)?.length > 0 ? calculateTotalCount('repeat') : 0}</h5>
                                </div>
                                <h3
                                    className={`cardsheadings ${viewType == "repeat" ? "active" : ''}`}
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: '600',
                                        color: '#623491',
                                        cursor: 'pointer'

                                    }}
                                    onClick={() => handleViewType("repeat")}
                                >
                                    Repeat <ArrowRightIcon />
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
            {
                viewType !== "" ?

                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12" style={{ marginTop: '40px' }}>


                                <div style={{ maxHeight: window.innerWidth > 1900 ? "1000px" : '500px', overflowY: 'auto', boxShadow:  tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ? '0px 0px 0px 8px rgba(0, 108, 103, 0.2)' : "rgba(77, 132, 199, 0.2) 0px 0px 0px 8px" }}>
                                    {allUserDetail && Object.keys(allUserDetail)?.length > 0 ? (
                                        Object.keys(allUserDetail).map((entry, i) => {
                                            const currentPage = paginationState[entry] || 1;
                                            const startIndex = (currentPage - 1) * itemsPerPage;
                                            const endIndex = startIndex + itemsPerPage;
                                            const sortedData = allUserDetail[entry] && allUserDetail[entry]?.length > 0 ? [...allUserDetail[entry]]?.sort((a, b) => {
                                                return (b?.currentlyAssigned == true) - (a?.currentlyAssigned == true);
                                            }) : [];
                                            // const paginatedData = sortedData && sortedData?.[entry]?.length > 0 ? sortedData[entry].slice(startIndex, endIndex) : [];
                                            const paginatedData = sortedData && sortedData?.length > 0 ? sortedData.slice(startIndex, endIndex) : [];
                                            return (
                                                <React.Fragment key={i}>
                                                    <Accordion
                                                        sx={{
                                                            " .MuiAccordionSummary-content": {
                                                                display: 'block',
                                                                width: '100%'
                                                            },
                                                            ".Mui-expanded": {
                                                                margin: '0',

                                                            },
                                                            ".css-eqpfi5-MuiAccordionSummary-content": {
                                                                margin: '0',
                                                            },
                                                            ".css-15v22id-MuiAccordionDetails-root": {
                                                                padding: '10px'
                                                            }
                                                        }}
                                                    >
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                            sx={{ background: i % 2 == 0 ? "#f7f9ff" : "#fff" }}
                                                        >
                                                            <Typography component="div">
                                                                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                                    <h5 style={{ color: '#000', margin: '0' }}>Assigned To</h5>
                                                                    <h5 style={{ color: '#000', margin: '0' }}>{entry}</h5>
                                                                    <h5 style={{ color: '#000', margin: '0 10px 0 0' }}>{allUserDetail?.[entry]?.length}</h5>
                                                                </div>
                                                            </Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <div className='DebtListMain'>
                                                                <div className='Sections'>
                                                                    <div className='tables' style={{ marginTop: '0' }}>
                                                                        <div className='phocket-table-new newTable'
                                                                            style={{ height: "auto", boxShadow: 'none' }}
                                                                        >
                                                                            {
                                                                                paginatedData && paginatedData?.length > 0 ?
                                                                                    <>
                                                                                        <table>
                                                                                            <thead>
                                                                                                <tr >
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Currently Assigned</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Details</th>
                                                                                                    {
                                                                                                        bulkAssign == true ?
                                                                                                            <th style={{ textAlign: 'center', minWidth: '140px' }}>Bulk Assign</th>
                                                                                                            : ''}
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Application Id</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Name</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Status</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Loan Amount</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '160px' }}>Apply Date</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '160px' }}>Salary</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Assigned At</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Touched On</th>
                                                                                                    <th style={{ textAlign: 'center', minWidth: '140px' }}>Completed On</th>


                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {
                                                                                                    paginatedData?.map((value, index) => {
                                                                                                        return (
                                                                                                            <tr>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center', background: value?.currentlyAssigned == true ? "#19d71959" : '#f03d3d99' }}>{value?.currentlyAssigned == true ? "Yes" : "No"}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                                                    <button onClick={e => userDetailHandler(value)}><span className="fa fa-info" /></button>
                                                                                                                </td>
                                                                                                                 {
                                                                                                                    bulkAssign == true ?
                                                                                                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                                                            <input type='checkbox' onChange={(e) => handleCheckbox(e, value)} checked={isItemSelected(value?.loanId)} />
                                                                                                                        </td>
                                                                                                                        : ''}
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.applicationId}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.name}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.loanStatus}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.loanAmount}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.applyDate}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.salary}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.assignedAt}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.touchedOn}</td>
                                                                                                                <td style={{ padding: '10px', textAlign: 'center' }}>{value?.completedOn}</td>



                                                                                                            </tr>
                                                                                                        )
                                                                                                    })
                                                                                                }

                                                                                            </tbody>
                                                                                        </table>
                                                                                    </>
                                                                                    : ""}

                                                                        </div>
                                                                        <div style={{ float: 'right', marginBottom: '15px', marginTop: '10px', display: 'flex', marginRight: '20px', justifyContent: 'end' }}>

                                                                            <Pagination size='large' onChange={(e, value) => handleChangeNewPagination(entry, value)} color="primary"
                                                                                count={Math.ceil(allUserDetail[entry].length / itemsPerPage)}
                                                                                page={paginationState[entry] || 1} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </React.Fragment>
                                            )
                                        })
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}

                       {
                assignPopup?.show ?
                    <div className="background-blur" style={{ zIndex: '99' }}>

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '400px', top: '5%' }}>
                            <i onClick={() => handleAssignmentPopup(false)} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div>
                                <h4 className='text-center'>Assign To</h4>

                                <select className='form-control' value={assignPopup?.selectedId} onChange={(e) => setAssingPopup((prev) => ({ ...prev, "selectedId": e.target.value }))}>
                                    <option>Select</option>
                                    {
                                        roleList && roleList?.length > 0 ? roleList?.map((Value, id) => {
                                            return (
                                                <option value={Value?.emailId}>{Value?.emailId}</option>
                                            )
                                        })
                                            : ''}
                                </select>
                                <div style={{ textAlign: 'center' }}>
                                    <button className='btn' style={{ marginTop: '22px', background: '#4d84c7', color: '#fff', padding: '10px' }} onClick={() => handleFinalAssignment()}>Assign</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    : ''}
        </>
    )
}
